import React, { useState } from "react";
import { AiOutlineCaretDown } from "react-icons/ai";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ComponentSEO from "../../components/SEO_Component/ComponentSEO";

function CardComparisonPage({ creditCards }) {
  const [selectedCard1, setSelectedCard1] = useState("");
  const [selectedCard2, setSelectedCard2] = useState("");
  const navigate = useNavigate();
  const {lang} = useParams();
  
  const cardOptions1 = creditCards.map((card) => ({
    id: card.id,
    name: card.title,
    card: card,
  }));

  const cardOptions2 = creditCards
    .filter((card) => card.id !== selectedCard1)
    .map((card) => ({
      id: card.id,
      name: card.title,
      card: card,
    }));

  const handleCard1Select = (event) => {
    setSelectedCard1(event.target.value);
  };

  const handleCard2Select = (event) => {
    setSelectedCard2(event.target.value);
  };

  const compareButton = () => {
    const filteredCreditCards1 = creditCards.filter(
      (creditCard) => creditCard.id === selectedCard1
    )[0];
    const filteredCreditCards2 = creditCards.filter(
      (creditCard) => creditCard.id === selectedCard2
    )[0];

    if (filteredCreditCards1 && filteredCreditCards2) {
      navigate(`/${lang}/credit-cards-compare/${selectedCard1+"-vs-"+selectedCard2}`);
    } else {
      alert("Select Both Card to compare");
    }
  };

  return (
    <div className="flex flex-col md:flex-row justify-center py-12">

      <ComponentSEO title={selectedCard1.title} desc={selectedCard2.title} />
      
      <div className="flex flex-col items-center px-4">
        <label className="text-lg font-medium mb-4">Select Card 1:</label>
        <div className="flex border border-gray-300 hover:border-gray-400 px-4 py-2 pr-8 rounded shadow">
          <select
            className="block text-black appearance-none bg-white focus:outline-none focus:none leading-tight"
            value={selectedCard1}
            onChange={handleCard1Select}
          >
            <option value="">Select a card</option>
            {cardOptions1.map((card, index) => (
              <option key={index} value={card.id}>
                {card.name}
              </option>
            ))}
          </select>
          <AiOutlineCaretDown className="h-8 " />
        </div>
      </div>
      <div className="flex flex-col items-center p-4 md:p-0 md:mx-4">
        <label className="text-lg font-medium mb-4">Select Card 2:</label>
        <div className="flex border border-gray-300 hover:border-gray-400 px-4 py-2 pr-8 rounded shadow">
          <select
            className="block text-black appearance-none bg-white focus:outline-none focus:none leading-tight"
            value={selectedCard2}
            onChange={handleCard2Select}
          >
            <option value="">Select a card</option>
            {cardOptions2.map((card, index) => (
              <option key={index} value={card.id}>
                {card.name}
              </option>
            ))}
          </select>
          <AiOutlineCaretDown className="h-8 " />
        </div>
      </div>
      <div className="mt-8 flex justify-center">
        <button
          className="132px md:w-[240px] h-[30px] md:h-[60px] rounded-[5px] md:rounded-[40px] bg-[#00C6CA] flex justify-center items-center text-[#ffffff] text-[14px] md:text-[24px] font-normal"
          onClick={compareButton}
        >
          Compare Now
        </button>
      </div>
    </div>
  );
}

export default CardComparisonPage;
